<script lang="ts" setup>
import { Icon } from '@iconify/vue'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const props = defineProps<{
  cover?: string
  label: string
  description?: string
  totalEpisodes?: number
}>()

const coverLoadError = ref(false)
</script>

<template>
  <div class="bg-gray-900 rounded-xl overflow-hidden cursor-pointer active:scale-95 transition-transform">
    <div class="aspect-3/4 bg-gray-800 relative">
      <img
        v-on:error="coverLoadError = true"
        v-if="cover && !coverLoadError"
        :src="cover"
        :alt="label"
        class="w-full h-full object-cover"
      />
      <div v-else class="w-full h-full flex items-center justify-center text-gray-600">
        <Icon icon="solar:video-library-bold-duotone" class="text-5xl" />
      </div>
      <!-- 剧集数标签 -->
      <div
        v-if="totalEpisodes"
        class="absolute top-2 right-2 bg-black/60 backdrop-blur-sm text-white text-xs px-2 py-1 rounded"
      >
        {{ t('component.theaterCard.episodeCount', { num: totalEpisodes }) }}
      </div>
    </div>
    <div class="p-3">
      <h3 class="text-white text-sm font-medium line-clamp-2 mb-1 h-10">{{ label }}</h3>
      <p v-if="description" class="text-gray-500 text-xs line-clamp-1">{{ description }}</p>
    </div>
  </div>
</template>
